import { ArrowTopRightOnSquareIcon, EnvelopeIcon, KeyIcon } from '@heroicons/react/24/outline';
import { FC } from 'react';

interface AccreditationProcessInfoProps {
  className?: string;
}

const AccreditationProcessInfo: FC<AccreditationProcessInfoProps> = ({ className = '' }) => {
  return (
    <div className={`col-span-full ${className}`}>
      <div className="rounded-lg border border-blue-200 bg-blue-50/50">
        <div className="p-4">
          {/* Header */}
          <div className="mb-3">
            <h3 className="text-sm font-medium text-slate-700">Accreditation Process</h3>
            <p className="text-xs text-slate-500 mt-0.5">
              Complete the accreditation process in the partner portal
            </p>
          </div>

          {/* Content */}
          <div className="space-y-3">
            {/* Step 1: Portal Opening */}
            <div className="flex gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <ArrowTopRightOnSquareIcon className="h-4 w-4 text-blue-400" />
              </div>
              <div className="flex-1">
                <p className="text-xs text-slate-600">
                  On submission, a new tab leading to a partner portal will open. Please complete
                  the accreditation process there.
                </p>
              </div>
            </div>

            {/* Step 2: Authentication Code */}
            <div className="flex gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <KeyIcon className="h-4 w-4 text-blue-400" />
              </div>
              <div className="flex-1">
                <p className="text-xs text-slate-600 mb-1.5">Use authentication code:</p>
                <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-blue-200 rounded-md">
                  <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                    Code
                  </span>
                  <span className="text-sm font-semibold text-blue-700 font-mono">ALTRUST</span>
                </div>
              </div>
            </div>

            {/* Step 3: Email Notification */}
            <div className="flex gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <EnvelopeIcon className="h-4 w-4 text-blue-400" />
              </div>
              <div className="flex-1">
                <p className="text-xs text-slate-600">The details will also be mailed to you.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccreditationProcessInfo;
